import React from "react";
import { Presets } from "rete-react-plugin";

const customItem = ({ hasSubitems, ...props }: any) => {
    const { Item } = Presets.contextMenu;
    return <Item {...props} />;
};

export default customItem;
